// @flow

import * as React from 'react';

import LegacyDispatcher from "app/lib/legacyDispatcher";

type Props = {
  uuid: string,
  url: string
};

export default class UploadedJobLink extends React.PureComponent<Props> {
  handleClick = () => {
    LegacyDispatcher.emit("job:focus", {
      job: {
        id: this.props.uuid,
        path: this.props.url
      }
    });
  }

  render() {
    return (
      <li>
        <a href={this.props.url} onClick={this.handleClick}>
          {this.props.uuid}
        </a>
      </li>
    );
  }
}